import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';
import React from 'react';

const SearchIcon: React.FC<SvgIconProps> = (props) => (
  <SvgIcon {...props} viewBox="0 0 24 24">
    <path
      d="M19 9l1.25-2.75L23 5l-2.75-1.25L19 1l-1.25 2.75L15 5l2.75 1.25L19 9zm-7.5.5L9 4 6.5 9.5 1 12l5.5 2.5L9 20l2.5-5.5L17 12l-5.5-2.5zm7.5 9.5l-1.25-2.75L15 15l2.75-1.25L19 11l1.25 2.75L23 15l-2.75 1.25L19 19z"
      fill="currentColor"
    />
  </SvgIcon>
);

export default SearchIcon;

